<template>
    <div class="field">
        <label class="label" v-if="props.etichetta!=null">{{ props.etichetta }}</label>
        <div class="select">
            <select  v-model="valoreCondizionato" :disabled="props.disabilitato" @change="modificaValore()">
                <option v-for="el in elencoDOM(props.idTendina, valoreCondizionato)" :value="el.valore" :key="el.valore">{{el.testo}}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";
    import { dbListini, dbClienti } from "@/code/gestioneDB";
    import { mostraListiniInattivi } from "@/code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        valore: {
            type: String,
            default: null
        },
        // identificativo: {
        //     type: String,
        //     default: ''
        // },
        disabilitato: {
            type: Boolean,
            default: false
        },
        idTendina: {
            type: String,
            default: ''
        },
        etichetta: {
            type: String,
            default: null
        },
        elencoValori: {
            type: Array,
            default: null
        }
    });
    const emit = defineEmits(['valoreCambiato']);

    // VARIABILI DEL COMPONENTE
    let valoreCondizionato = ref(props.valore);

    // FUNZIONI DEL COMPONENTE
    function modificaValore() {
        // emit('valoreCambiato', valoreCondizionato.value, props.identificativo);
        emit('valoreCambiato', valoreCondizionato.value);
    }

    function elencoDOM(nomeElenco, valoreAttuale) {
        // Restituisce un elenco da usare per creare i menu a tendina
        // ad esempio l'elenco dei clienti
        let tempElenco = [];
        if (props.elencoValori!=null) {
            // E' stato passato l'elenco dei valori da visualizzare
            tempElenco = props.elencoValori;
            return tempElenco;
        } else {
            // Non è stato passato l'elenco dei valori da visualizzare
            // quindi viene creato in base al nome dell'elenco
            switch (nomeElenco) {
                case 'lead.stato':
                    tempElenco = [
                        {'valore':'In attesa', 'testo':'In attesa'},
                        {'valore':'In verifica', 'testo':'In verifica'},
                        {'valore':'Archiviato', 'testo':'Archiviato'},
                        {'valore':'Non processato', 'testo':'Non processato'},
                        {'valore':'Urgente', 'testo':'Urgente'}
                    ];
                    break;
                    case 'lead.fase':
                    tempElenco = [
                        {'valore':'Contatto', 'testo':'Contatto'},
                        {'valore':'Sopralluogo', 'testo':'Sopralluogo'},
                        {'valore':'Preventivo', 'testo':'Preventivo'},
                        {'valore':'Ordine cliente', 'testo':'Ordine cliente'},
                        {'valore':'Chiuso', 'testo':'Chiuso'}
                    ];
                    break;
                    case 'lead.primoContattoFonte':
                    tempElenco = [
                        {'valore':'Segnalazione', 'testo':'Segnalazione'},
                        {'valore':'Cliente', 'testo':'Cliente'},
                        {'valore':'Vetrina', 'testo':'Vetrina'},
                        {'valore':'Vitoadvisor', 'testo':'Vitoadvisor'},
                        {'valore':'Sito internet', 'testo':'Sito internet'}
                    ];
                    break;
                case 'lavoro.tipo':
                    tempElenco = [
                        {'valore':'Caldaia a gas', 'testo':'Caldaia a gas'},
                        {'valore':'Caldaia a biomassa', 'testo':'Caldaia a biomassa'},
                        {'valore':'Pompa di calore', 'testo':'Pompa di calore'},
                        {'valore':'Pompa di calore ACS', 'testo':'Pompa di calore ACS'},
                        {'valore':'Generatore ibrido', 'testo':'Generatore ibrido'},
                        {'valore':'Condizionatore', 'testo':'Condizionatore'},
                        {'valore':'VRF', 'testo':'VRF'},
                        {'valore':'Impianto fotovoltaico', 'testo':'Impianto fotovoltaico'},
                        {'valore':'Impianti generali', 'testo':'Impianti generali'},
                        {'valore':'Lavoro', 'testo':'Lavoro'},
                        {'valore':'Fornitura', 'testo':'Fornitura'},
                        {'valore':'Altro', 'testo':'Altro'}
                    ];
                    break;
                case 'lavoro.detrazione':
                    tempElenco = [
                        {'valore':null, 'testo':'-seleziona la detrazione'},
                        {'valore':'Nessuna detrazione', 'testo':'Nessuna detrazione'},
                        {'valore':'Bonus Casa 36%', 'testo':'Bonus Casa 36%'},
                        {'valore':'Bonus Casa 50%', 'testo':'Bonus Casa 50%'},
                        {'valore':'Ecobonus 50%', 'testo':'Ecobonus 50%'},
                        {'valore':'Ecobonus 65%', 'testo':'Ecobonus 65%'},
                        {'valore':'Superbonus 110%', 'testo':'Superbonus 110%'},
                        {'valore':'Conto termico', 'testo':'Conto termico'},
                        {'valore':'40% PNRR', 'testo':'40% PNRR'}
                    ];
                    break;
                case 'preventivo.iva':
                    tempElenco = [
                        {'valore':null, 'testo':'-seleziona il regime Iva'},
                        {'valore':'Non esporre Iva', 'testo':'Non esporre Iva'},
                        {'valore':'Ordinaria 22%', 'testo':'Ordinaria 22%'},
                        {'valore':'Manutenzione straord. 10%-22%', 'testo':'Manutenzione straord. 10%-22%'},
                        {'valore':'Manutenzione straord. 10%', 'testo':'Manutenzione straord. 10%'},
                        {'valore':'Ristrutturazione 10%', 'testo':'Ristrutturazione 10%'},
                        {'valore':'Reverse charge', 'testo':'Reverse charge'},
                        {'valore':'Scissione dei pagamenti art. 17-ter', 'testo':'Scissione dei pagamenti art. 17-ter'},
                        {'valore':'Iva ridotta 4%', 'testo':'Iva ridotta 4%'}
                    ];
                    break;
                case 'preventivo.rateizzazione':
                    tempElenco = [
                        {'valore':null, 'testo':'-seleziona il tipo di rateizzazione'},
                        {'valore':'Rate normali', 'testo':'Rate normali'},
                        {'valore':'Rata fissa', 'testo':'Rata fissa'}
                    ];
                    break;
                case 'lavoro.iva':
                    tempElenco = [
                        {'valore':null, 'testo':'-seleziona il regime Iva'},
                        {'valore':'Ordinaria 22%', 'testo':'Ordinaria 22%'},
                        {'valore':'Manutenzione straord. 10%-22%', 'testo':'Manutenzione straord. 10%-22%'},
                        {'valore':'Manutenzione straord. 10%', 'testo':'Manutenzione straord. 10%'},
                        {'valore':'Ristrutturazione 10%', 'testo':'Ristrutturazione 10%'},
                        {'valore':'Reverse charge', 'testo':'Reverse charge'},
                        {'valore':'Scissione dei pagamenti art. 17-ter', 'testo':'Scissione dei pagamenti art. 17-ter'},
                        {'valore':'Iva ridotta 4%', 'testo':'Iva ridotta 4%'}
                    ];
                    break;
                case 'fase.stato':
                    tempElenco = [
                        {'valore':'Non iniziabile', 'testo':'Non iniziabile'},
                        {'valore':'Nuovo', 'testo':'Nuovo'},
                        {'valore':'In attesa', 'testo':'In attesa'},
                        {'valore':'In lavorazione', 'testo':'In lavorazione'},
                        {'valore':'In verifica', 'testo':'In verifica'},
                        {'valore':'Eseguito', 'testo':'Eseguito'},
                        {'valore':'Sospeso', 'testo':'Sospeso'},
                        {'valore':'Urgente', 'testo':'Urgente'}
                    ];
                    break;
                case 'fase.categoria':
                    tempElenco = [
                        {'valore':'Documentazione', 'testo':'Documentazione'},
                        {'valore':'Lavoro', 'testo':'Lavoro'}
                    ];
                    break;
                case 'fase.responsabile':
                    tempElenco = [
                        {'valore':'Marco Cauda', 'testo':'Marco Cauda'},
                        {'valore':'Giorgia Gariglio', 'testo':'Giorgia Gariglio'},
                        {'valore':'Luca Martinetto', 'testo':'Luca Martinetto'},
                        {'valore':'Federico Martinetto', 'testo':'Federico Martinetto'},
                        {'valore':'Luca Ponte', 'testo':'Luca Ponte'}
                    ];
                    break;
                    case 'fase.oggetto.documentazione':
                    tempElenco = [
                        {'valore':'Richiesta dati anagrafici', 'testo':'Richiesta dati anagrafici'},
                        {'valore':'Redazione POS', 'testo':'Redazione POS'},
                        {'valore':'Apertura pratica e-distribuzione', 'testo':'Apertura pratica e-distribuzione'},
                        {'valore':'Chiusura pratica e-distribuzione', 'testo':'Chiusura pratica e-distribuzione'},
                        {'valore':"Verbale d'esercizio", 'testo':"Verbale d'esercizio"},
                        {'valore':'Accesso CER AEG', 'testo':'Accesso CER AEG'},
                        {'valore':'Pratica 40% PNRR', 'testo':'Pratica 40% PNRR'},
                        {'valore':'Richiesta allacciamento gas', 'testo':'Richiesta allacciamento gas'},
                        {'valore':'Redazione DiCo', 'testo':'Redazione DiCo'},
                        {'valore':'Redazione CME', 'testo':'Redazione CME'},
                        {'valore':'Resoconto lavori', 'testo':'Resoconto lavori'},
                        {'valore':'Comunicazione f-gas', 'testo':'Comunicazione f-gas'},
                        {'valore':'Comunicazione ENEA', 'testo':'Comunicazione ENEA'},
                        {'valore':'Conto termico', 'testo':'Conto termico'},
                        {'valore':'Aggiornamento libretto di impianto', 'testo':'Aggiornamento libretto'},
                        {'valore':'Rapporto di efficienza', 'testo':'Rapporto di efficienza'},
                        {'valore':'Dichiarazione IVA agevolata', 'testo':'Dichiarazione IVA agevolata'},
                        {'valore':'Fatturazione', 'testo':'Fatturazione'},
                        {'valore':'Preparazione pacchetto documenti', 'testo':'Preparazione pacchetto documenti'},
                        {'valore':'Consegna documenti', 'testo':'Consegna documenti'},
                        {'valore':'Comunicazione INAIL', 'testo':'Comunicazione INAIL'},
                        {'valore':'Estensione garanzia', 'testo':'Estensione garanzia'},
                        {'valore':'Altri documenti', 'testo':'Altri documenti'}
                    ];
                    break;
                case 'fase.oggetto.lavoro':
                    tempElenco = [
                        {'valore':'Ordine materiale', 'testo':'Ordine materiale'},
                        {'valore':'Progetto pannelli radianti', 'testo':'Progetto pannelli radianti'},
                        {'valore':'Adeguamento contatore elettrico', 'testo':'Adeguamento contatore elettrico'},
                        {'valore':'Lavoro', 'testo':'Lavoro'},
                        {'valore':'Consegna materiale', 'testo':'Consegna materiale'},
                        {'valore':'Prima accensione', 'testo':'Prima accensione'},
                        {'valore':'Attivazione off-grid', 'testo':'Attivazione off-grid'},
                        {'valore':'Attivazione on-grid', 'testo':'Attivazione on-grid'},
                        {'valore':'Intervento in garanzia', 'testo':'Intervento in garanzia'}
                    ];
                    break;
                case 'dico.stato':
                    tempElenco = [
                        {'valore':'In lavorazione', 'testo':'In lavorazione'},
                        {'valore':'Eseguito', 'testo':'Eseguito'}
                    ];
                    break;
                case 'listini':
                    tempElenco = [];
                    for (const listino in dbListini.value) {
                        const info = dbListini.value[listino]?.informazioni;
                        const isAttivo = info ? info.attivo !== false : true;
                        if (mostraListiniInattivi.value || isAttivo || String(listino) === String(valoreAttuale)) {
                            tempElenco.push({
                                'valore': listino,
                                'testo': info?.nome || listino
                            });
                        }
                    }
                    // Ordino tempElenco secondo il nome del listino
                    tempElenco.sort( (a, b) => {
                        let x = a.testo.toLowerCase();
                        let y = b.testo.toLowerCase();
                        if (x == 'lmc 2025') {return -1;}
                        if (y == 'lmc 2025') {return 1;}
                        if (x < y) {return -1;}
                        if (x > y) {return 1;}
                        return 0;
                    });
                    break;
                case 'tipoCosto':
                    tempElenco = [
                        {'valore':'lavoro', 'testo':'Lavoro'},
                        {'valore':'costo', 'testo':'Costo'}
                    ];
                    break;
                case 'lavoratore':
                    tempElenco = [
                        {'valore':'Edoardo Balmino', 'testo':'Edoardo Balmino'},
                        {'valore':'Francesco Bianco', 'testo':'Francesco Bianco'},
                        {'valore':'Igor Canazza', 'testo':'Igor Canazza'},
                        {'valore':'Mohamed Amin Hadidane', 'testo':'Mohamed Amin Hadidane'},
                        {'valore':'Michel Hellin', 'testo':'Michel Hellin'},
                        {'valore':'Davide Raimondi', 'testo':'Davide Raimondi'},
                        {'valore':'Luca Martinetto', 'testo':'Luca Martinetto'},
                        {'valore':'Federico Martinetto', 'testo':'Federico Martinetto'},
                        {'valore':'Marco Cauda', 'testo':'Marco Cauda'},
                        {'valore':'Esterno', 'testo':'Esterno'}
                    ];
                    break;
                case 'lavoroAttivo':
                    tempElenco = [];
                    for(const cl in dbClienti.value){
                        for(const lv in  dbClienti.value[cl].lavori){
                            for(const fs in  dbClienti.value[cl].lavori[lv].fasi){
                                // Se la fase è 'In lavorazione' o 'Urgente' ed è di tipo 'lavoro' con 'giorni-squadra'
                                // la aggiunge all'elenco
                                if ( ( dbClienti.value[cl].lavori[lv].fasi[fs].stato == 'In lavorazione'
                                    || dbClienti.value[cl].lavori[lv].fasi[fs].stato == 'Urgente' )
                                    && ( dbClienti.value[cl].lavori[lv].fasi[fs].categoria == 'Lavoro'
                                    && dbClienti.value[cl].lavori[lv].fasi[fs].lavoroStima > 0 ) ) {
                                    tempElenco.push({
                                        'valore': String(dbClienti.value[cl].lavori[lv].fasi[fs].info.idLavoro),
                                        'testo': dbClienti.value[cl].lavori[lv].fasi[fs].info.stringaLavoro
                                    });
                                }
                            }
                        }
                    }
                    break;
                case 'tipiVocePreventivo':
                    tempElenco = [
                        {'valore':'Titolo', 'testo':'Titolo'},
                        {'valore':'Articolo', 'testo':'Articolo'},
                        {'valore':'Nota', 'testo':'Nota'}
                    ];
                    break;
                case 'lead.propostaAegTipo':
                case 'lead.contrattoAegTipo':
                    tempElenco = [
                        {'valore':'', 'testo':''},
                        {'valore':'Luce', 'testo':'Luce'},
                        {'valore':'Gas', 'testo':'Gas'},
                        {'valore':'Luce e Gas', 'testo':'Luce e Gas'}
                    ];
                    break;
                case 'ricarico.fonte':
                    tempElenco = [
                        {'valore':'Listino', 'testo':'Listino'},
                        {'valore':'Costo', 'testo':'Costo'}
                    ];
                    break;
                case 'vocePreventivo.beneSignificativo':
                    tempElenco = [
                        {'valore':'No', 'testo':'No'},
                        {'valore':'Prezzo', 'testo':'Prezzo'},
                        {'valore':'Costo', 'testo':'Costo'}
                    ];
                    break;
                default:
                    break;
            }
            // Se è stato passato valoreAttuale verifica se è presente nell'elenco
            // se non è presente aggiunge il valore all'elenco
            if (valoreAttuale) {
                let tempPresente = false;
                for (let i = 0; i < tempElenco.length; i++) {
                    if (tempElenco[i].valore == valoreAttuale) {
                        tempPresente = true;
                    }
                }
                if (!tempPresente) {
                    tempElenco.push({
                        'valore':valoreAttuale,
                        'testo':valoreAttuale
                    });
                }        
            }
            return tempElenco;
        }
    }
</script>